/**
 * Extremely Basic Module Registry
 * Designed to prevent asynchronously modules from being loaded and run more than once.
 * @author Rhys Lloyd
 */

//
// Utilities
import debug from "debug";
const MODULE_NAME = 'registry';
const log = debug(MODULE_NAME);

//
// Dependencies
import State from './state';

//
// Constants
const REGISTRY = {};
export const STATE = State;
export * from './names';

//
// Functions

import * as dl from './dynamic-loader';

/**
 * Registers a module.
 * @param module
 * @param state
 * @returns {*}
 */
export function register (module, state) {
	if (exists(module)) {
		log(`register(): Attempting to re-register an existing module: "${module}"`, 'Existing:', REGISTRY[module]);
		return;
	}

	if (!state || !validState(state)) {
		state = STATE.INIT;
	}

	REGISTRY[module] = {
		state: state
	};

	log(`register(): Registering module "${module}" with state "${state.name}"`);
	return REGISTRY[module];
}

/**
 * Returns the object in the registry
 * @param module
 * @returns {*}
 */
export function exists (module) {
	return !!REGISTRY[module];
}

/**
 * Checks if a module is marked as registered.
 * @param module
 * @returns {*|boolean}
 */
export function isRegistered (module) {
	return exists(module) && getState(module) == STATE.REGISTERED;
}

/**
 * Get the state of a registered module.
 * @param module
 * @returns {*}
 */
export function getState (module) {
	if (!exists(module)) {
		log(`getState(): module "${module}" doesn't exist`);
		return;
	}

	let state = REGISTRY[module].state;
	log(`getState(): Getting state "${state.name}" for module "${module}"`);
	return state;
}

/**
 * Get the state of a registered module.
 * @param module
 * @param state
 * @returns {*}
 */
export function setState (module, state) {
	if (!exists(module)) {
		log(`setState(): module "${module}" doesn't exist`);
		return;
	}

	if (!validState(state)) {
		log(`setState(): state "${state}" doesn't exist (attempt on module "${module}")`);
	}

	log(`setState(): Setting state "${state.name}" for module "${module}"`);
	REGISTRY[module].state = state;
}

/**
 * Verifies that a state is valid
 * @param state
 * @returns {boolean}
 */
export function validState (state) {
	return state instanceof State;
}

export { register as default };

export function dynamicLoader(module, selector, loadArray) {
	return dl.default(module, selector, loadArray);
}


// WEBPACK FOOTER //
// ./project/client/src/core/registry/index.js